module.exports = __webpack_public_path__ + "static/media/bike-creation-in-workshop.cdbff04a.jpg";